const partnerUserRolesOptions: { [key: string]: string } = {
  Admin: 'Admin',
  Support: 'Support',
  Viewer: 'Viewer'
};

export default partnerUserRolesOptions;
